import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HelpLabelComponent } from '../../../../../common-shared-module/components/help-label/help-label.component';
import { DataSourceItemMetadata } from '../../../../../common-shared-module/model/dyn-form/form-metadata/item/datasource-item-metadata.model';
import { MetadataChange } from '../../../../models/metadata-change.model';
import { CsvParserService } from '../../../../services/csv/csv-parser.service';
import { SectionMetadataService } from '../../../../services/section-metadata/section-metadata.service';

@Component({
    selector: 'app-chained-select-metadata-editor',
    templateUrl: './chained-select-metadata-editor.component.html',
    styleUrl: './chained-select-metadata-editor.component.scss',
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, ClipboardModule, 
        HelpLabelComponent,
        MatIconModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatDividerModule, MatInputModule, MatButtonModule
    ]
})
export class ChainedSelectMetadataEditorComponent {

    @Input() item!: DataSourceItemMetadata

    @Output() changeItem: EventEmitter<MetadataChange> = new EventEmitter()


    currentItem!: DataSourceItemMetadata
    family: DataSourceItemMetadata[] = []
    singleSelects: DataSourceItemMetadata[] = []

    fieldForm: FormGroup

    constructor(
        protected sectionMetadataService: SectionMetadataService, private fb: FormBuilder,
        protected csvParser: CsvParserService,
        protected snack: MatSnackBar,
    ) {
        this.fieldForm = this.fb.group({
            csv: [''],
        });
    }

    ngOnInit(): void {
        this.currentItem = this.item
        this.refresh()
        this.fieldForm.patchValue({ csv: this.csvParser.calculateCsv(this.family) })
    }

    findFamily(): DataSourceItemMetadata[] {
        return this.family
    }

    findSingleDataSourceItemMetadata(): DataSourceItemMetadata[] {
        return this.singleSelects
    }

    removeParent(ds: DataSourceItemMetadata) {
        this.family.forEach(f => { f.clear() })
        ds.parentSelectFieldName = null
        this.refresh();
        this.fieldForm.patchValue({ csv: this.csvParser.calculateCsv(this.family) })
        let mc = new MetadataChange();
        mc.changed.push(ds)
        this.changeItem.emit(mc)
    }

    changeValue($event: DataSourceItemMetadata | null) {
        if ($event == null) {
            return
        }
        let f = this.findFamily()
        $event.parentSelectFieldName = f[f.length - 1].fieldName
        this.refresh();

    }


    private refresh() {
        this.family = this.sectionMetadataService.searchFamily(this.currentItem);
        this.singleSelects = this.sectionMetadataService.findSingleSelect(this.currentItem);
    }

    importCsv() {

        let result = this.csvParser.createOptions(this.fieldForm.controls["csv"].value, this.family)
        if (result.ok == false) {
            this.snack.open(result.message)
            return
        }

        let mc = new MetadataChange();
        this.family.forEach(f => {
            mc.changed.push(f)
        })
        this.changeItem.emit(mc)
        this.snack.open("Importació correcta")
    }

    createExample(): string {
        let example: string[] = []
        let count = 0
        for (let index = 0; index < 10; index++) {
            let line: string[] = []
            for (let i = 0; i < this.family.length; i++) {
                line[i] = `Camp ${count++}`
            }
            example[index] = `${line.join(';')}`
        }

        return example.join("\n")
    }

}
